import React, { useEffect, useState, useMemo } from 'react'
import Swiper from '../../../../../components/swiper/autowidth'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import withSource from '../../../../../hocs/source-scoll'
import { FormattedMessage } from 'react-intl'

const getDayMonthFromLong = ldate => {
    const date = new Date(ldate)
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()

    const current = new Date()

    if (day === current.getDate() && month === current.getMonth() + 1 && year === current.getFullYear()) {
        return <FormattedMessage id="today" defaultMessage={'Today'} />
    }

    if (day === current.getDate() - 1 && month === current.getMonth() + 1 && year === current.getFullYear()) {
        return <FormattedMessage id="yesterday" defaultMessage={'Yesterday'} />
    }

    return `${day < 10 ? '0' : ''}${day}/${month < 10 ? '0' : ''}${month}`
}


export const withSwiper = Wrapped => {

    return props => {
        const { items, onTab, selectedIndex } = props

        const [selectedItem, setSelectedItem] = useState()

        useEffect(() => {
            setSelectedItem(items?.[selectedIndex || 0] || items?.[0])
        }, [items])

        const handleClick = (item, index) => {
            setSelectedItem(item)
            onTab(item, index)
        }


        const tabClick = (s, e) => {
            if (s.clickedIndex === s.activeIndex || s.clickedIndex === s.activeIndex + 1) {
                s.slidePrev(300)
            } else {
                s.slideToClosest(300)
            }
        }


        return <Wrapped {...props} tabClick={tabClick} selectedItem={selectedItem} handleClick={handleClick} />
    }
}

const Tab1 = withSource(props => {
    useStyles(classes)
    const { selectedItem, innerRef, sensors, item, handleClick, position } = props
    return <span
        ref={innerRef}
        data-position={`${sensors?.position || 1}-${(position || 0) + 1}`}
        data-type={sensors?.type}
        data-content={item.title || item.name}
        data-title={sensors?.title}
        onClick={() => { handleClick(item, position) }}
        className={`${classes.Tab} ${selectedItem?.id === item?.id ? classes.Selected : ''}`}>{item.title || item.name}</span>
})

export const TabSwiper1 = withSwiper(props => {
    useStyles(classes)
    const { items, tabClick } = props

    return <div className={classes.TabSwiper1}>
        <Swiper options={{
            slidesPerView: 'auto',
            slideToClickedSlide: true,
            onClick: tabClick
        }} items={items} render={(item, index) => {
            return <Tab1 {...props} item={item} position={index} />
        }} />
    </div>
})




const Tab2 = withSource(props => {
    useStyles(classes)
    const { selectedItem, innerRef, sensors, item, handleClick, position } = props
    return <span
        ref={innerRef}
        data-position={`${sensors?.position || 1}-${(position || 0) + 1}`}
        data-type={sensors?.type}
        data-content={item.title || item.name}
        data-title={sensors?.title}
        onClick={() => { handleClick(item, position) }} className={`${classes.Tab} ${selectedItem?.id === item?.id ? classes.Selected : ''}`}>{item.title || item.name}</span>
})

const SpecialTab2 = withSource(props => {
    useStyles(classes)
    const { selectedItem, innerRef, sensors, item, handleClick, position } = props
    return <a 
        ref={innerRef}
        data-position={`${sensors?.position || 1}-${(position || 0) + 1}`}
        data-type={sensors?.type}
        data-content={item.title || item.name}
        data-title={sensors?.title}
        onClick={() => { handleClick(item, position) }} 
        className={classes.SpecialTab}
    >
        <span className={`${classes.Tab} ${selectedItem?.id === item?.id ? classes.Selected : ''}`}>{item.title || item.name}</span>
    </a>
})


export const TabSwiper2 = withSwiper(props => {
    useStyles(classes)
    const { items, tabClick, isSpecial } = props
    return <div className={classes.TabSwiper2}>
        <Swiper options={{
            slidesPerView: isSpecial ? 2 : 'auto',
            slideToClickedSlide: true,
            spaceBetween: isSpecial ? 0 : 18,
            onClick: tabClick
        }} items={items} render={(item, index) => {
            return <React.Fragment>
                {
                   isSpecial ? <SpecialTab2 {...props} item={item} position={index} /> :  <Tab2 {...props} item={item} position={index} />
                }
            </React.Fragment>
        }} />
    </div>
})


const Tab3 = withSource(props => {
    useStyles(classes)
    const { selectedItem, innerRef, sensors, item, handleClick, position, theme } = props
    const isActive = selectedItem?.id === item?.id
    return <span
        ref={innerRef}
        data-position={`${sensors?.position || 1}-${(position || 0) + 1}`}
        data-type={sensors?.type}
        data-content={item.title || item.name}
        data-title={sensors?.title}
        onClick={() => { handleClick(item, position) }} className={`${classes.Tab} ${isActive ? classes.Selected : ''}`}
        style={{
            backgroundColor: isActive? theme?.activeBackgroundColor: theme?.backgroundColor,
            borderColor: isActive? (theme?.activeBorderColor || theme?.activeBackgroundColor): theme?.borderColor,
            color: isActive? theme?.activeTextColor: theme?.textColor
        }}>{item.title || item.name}</span>
})


export const TabSwiper3 = withSwiper(props => {
    useStyles(classes)
    const { items, tabClick } = props
    return <div className={`${classes.TabSwiper3} ${items?.length === 2 ? classes.DoubleItem: ''}`}>
        <Swiper options={{
            slidesPerView: items?.length === 2? 2: 'auto',
            spaceBetween: 12,
            slideToClickedSlide: true,
            onClick: tabClick
        }} className={classes.SwiperContainer} items={items} render={(item, index) => {
            return <Tab3 {...props} item={item} position={index} />
        }} />
    </div>
})

const Tab4 = withSource(props => {
    useStyles(classes)
    const { selectedItem, innerRef, sensors, item, handleClick, position, theme } = props

    let normalStyle = useMemo(() => ({
        color: theme?.normalFontColor || "#222",
        backgroundColor: theme?.normalFontBgColor || "#fff"
    }), []);

    let activeStyle = useMemo(() => ({
        color: theme?.activeFontColor || "#fff",
        backgroundColor: theme?.activeFontBgColor || "#222"
    }), [])

    return <span
        ref={innerRef}
        data-position={`${sensors?.position || 1}-${(position || 0) + 1}`}
        data-type={sensors?.type}
        data-content={item.title || item.name}
        data-title={sensors?.title}
        onClick={() => { handleClick(item, position) }}
        style={selectedItem?.id === item?.id ? activeStyle : normalStyle}
        className={`${classes.Tab}`}>{item.title || item.name}</span>
})

export const TabSwiper4 = withSwiper(props => {
    useStyles(classes)
    const { items, tabClick } = props
    return <div className={classes.TabSwiper4}>
        <Swiper options={{
            slidesPerView: 'auto',
            spaceBetween: 12,
            slideToClickedSlide: true,
            onClick: tabClick
        }} className={classes.SwiperContainer} items={items} render={(item, index) => {
            return <Tab4 {...props} item={item} position={index} />
        }} />
    </div>
})



const TabFestival = withSource(props => {
    useStyles(classes)
    const { selectedItem, innerRef, sensors, item, handleClick, position, activeColor } = props
    return <span
        ref={innerRef}
        data-position={`${sensors?.position || 1}-${(position || 0) + 1}`}
        data-type={sensors?.type}
        data-content={item.title || item.name}
        data-title={sensors?.title}
        onClick={() => { handleClick(item, position) }} className={`${classes.Tab} ${selectedItem?.id === item?.id ? classes.Selected : ''}`} style={{ backgroundColor: activeColor }}>{item.title || item.name}</span>
})


export const TabSwiperFestival = withSwiper(props => {
    useStyles(classes)
    const { items, tabClick } = props
    return <div className={classes.TabSwiperFestival}>
        <Swiper options={{
            slidesPerView: 'auto',
            spaceBetween: 12,
            slideToClickedSlide: true,
            onClick: tabClick
        }} className={classes.SwiperContainer} items={items} render={(item, index) => {
            return <TabFestival {...props} item={item} position={index} />
        }} />
    </div>
})


const TabDaily = withSource(props => {
    useStyles(classes)
    const { selectedItem, innerRef, sensors, item, handleClick, position } = props
    return <span
        ref={innerRef}
        data-position={`${sensors?.position || 1}-${(position || 0) + 1}`}
        data-type={sensors?.type}
        data-content={item.title || item.name}
        data-title={sensors?.title}
        onClick={() => { handleClick(item, position) }} className={`${classes.Tab} ${selectedItem?.id === item?.id ? classes.Selected : ''}`}>
        <span className={classes.Date}>{getDayMonthFromLong(item.startDate)}</span>
        <span className={classes.Count}>{item?.count}</span>
        <span className={classes.Arrivals}>New Arraivals</span>
    </span>
})


export const TabSwiperDaliyNew = withSwiper(props => {
    useStyles(classes)
    const { items, tabClick, selectedItem } = props
    return <div className={classes.TabSwiperDaliyNew}>
        <Swiper options={{
            slidesPerView: 'auto',
            slideToClickedSlide: true,
            onClick: tabClick
        }} className={classes.SwiperContainer} items={items} render={(item, index) => {
            return <TabDaily {...props} item={item} position={index} />
        }} />
    </div>
})


const Tab5 = withSource(props => {
    useStyles(classes)
    const { selectedItem, innerRef, sensors, item, handleClick, position, theme } = props
    const isActive = selectedItem?.id === item?.id
    return <span
        ref={innerRef}
        data-position={`${sensors?.position || 1}-${(position || 0) + 1}`}
        data-type={sensors?.type}
        data-content={item.title || item.name}
        data-title={sensors?.title}
        onClick={() => { handleClick(item, position) }} className={`${classes.Tab} ${isActive ? classes.Selected : ''}`}
        style={{
            backgroundColor: isActive? theme?.activeBackgroundColor: theme?.backgroundColor,
            borderColor: isActive? theme?.activeBackgroundColor: undefined,
            color: isActive? theme?.activeTextColor: theme?.textColor
        }}>{item.title || item.name}</span>
})


export const TabSwiper5 = withSwiper(props => {
    useStyles(classes)
    const { items, tabClick } = props
    return <div className={classes.TabSwiper5}>
        <Swiper options={{
            slidesPerView: 'auto',
            spaceBetween: 12,
            slideToClickedSlide: true,
            onClick: tabClick
        }} className={classes.SwiperContainer} items={items} render={(item, index) => {
            return <Tab5 {...props} item={item} position={index} />
        }} />
    </div>
})





const TabCus = withSource(props => {
    useStyles(classes)
    const { selectedItem, innerRef, sensors, item, handleClick, position, theme } = props
    const isActive =selectedItem?.id === item?.id
    return <span
        style={{
            borderColor: isActive? theme?.activeBorderColor: theme?.borderColor,
            color: isActive? theme?.activeTextColor: theme?.textColor
        }}
        ref={innerRef}
        data-position={`${sensors?.position || 1}-${(position || 0) + 1}`}
        data-type={sensors?.type}
        data-content={item.title || item.name}
        data-title={sensors?.title}
        onClick={() => { handleClick(item, position) }} className={`${classes.Tab} ${isActive ? classes.Selected : ''}`}>{item.title || item.name}</span>
})


export const TabSwiperCus = withSwiper(props => {
    useStyles(classes)
    const { items, tabClick, isSpecial } = props
    return <div className={classes.TabSwiperCus}>
        <Swiper options={{
            slidesPerView: isSpecial ? 2 : 'auto',
            slideToClickedSlide: true,
            spaceBetween: isSpecial ? 0 : 18,
            onClick: tabClick
        }} items={items} render={(item, index) => {
            return <TabCus {...props} item={item} position={index} />
        }} />
    </div>
})